var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "welcomeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009688"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "confettiPattern",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 1.5,
    fill: "#FFF",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 30,
    r: 2.5,
    fill: "#FFF",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 70,
    r: 1.8,
    fill: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 65,
    width: 3,
    height: 3,
    fill: "#FFF",
    opacity: 0.15,
    transform: "rotate(30, 25, 65)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 85,
    width: 4,
    height: 2,
    fill: "#FFF",
    opacity: 0.2,
    transform: "rotate(15, 60, 85)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#welcomeGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#confettiPattern)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -40,
    width: 70,
    height: 60,
    rx: 3,
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -35,
    width: 60,
    height: 50,
    rx: 2,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -45,
    width: 5,
    height: 70,
    fill: "#9C27B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -15,
    width: 80,
    height: 5,
    fill: "#9C27B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -30,
    width: 50,
    height: 45,
    rx: 3,
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: -25,
    width: 40,
    height: 35,
    rx: 2,
    fill: "#7986CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: -35,
    width: 4,
    height: 55,
    fill: "#1A237E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -10,
    width: 60,
    height: 4,
    fill: "#1A237E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 40,
    height: 35,
    rx: 3,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35,
    width: 30,
    height: 25,
    rx: 2,
    fill: "#FFECB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 3,
    height: 45,
    fill: "#FF6F00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 45,
    width: 50,
    height: 3,
    fill: "#FF6F00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 10,
    height: 5,
    rx: 1,
    fill: "#F44336",
    transform: "rotate(30, -70, -50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -30,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#2196F3",
    transform: "rotate(-15, -40, -30)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -55,
    cy: -10,
    r: 4,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 10,
    width: 12,
    height: 6,
    rx: 1,
    fill: "#FF9800",
    transform: "rotate(45, -20, 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -40,
    width: 9,
    height: 4,
    rx: 1,
    fill: "#9C27B0",
    transform: "rotate(60, 0, -40)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -20,
    r: 3.5,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 10,
    height: 5,
    rx: 1,
    fill: "#03A9F4",
    transform: "rotate(-30, 30, 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 20,
    r: 4,
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,-30 L40,10 L80,10 Z",
    fill: "#9C27B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,-30 L60,10",
    stroke: "#E1BEE7",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: -35,
    r: 5,
    fill: "#E91E63"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 30,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#FF5722",
    transform: "rotate(20, 200, 30)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 50,
    r: 3,
    fill: "#FFEB3B",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 40,
    width: 10,
    height: 5,
    rx: 1,
    fill: "#2196F3",
    transform: "rotate(-15, 300, 40)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 30,
    r: 2.5,
    fill: "#4CAF50",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 50,
    width: 7,
    height: 3.5,
    rx: 1,
    fill: "#9C27B0",
    transform: "rotate(45, 400, 50)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 40,
    r: 3,
    fill: "#F44336",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 30,
    width: 9,
    height: 4.5,
    rx: 1,
    fill: "#FF9800",
    transform: "rotate(-30, 500, 30)",
    opacity: 0.7
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#FFF",
    textAnchor: "middle"
  }, "WELCOME OFFER")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 115,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#FFF",
    textAnchor: "middle"
  }, "10% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 145,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#FFF",
    textAnchor: "middle"
  }, "For new customers on their first purchase")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomer);
export default __webpack_public_path__ + "static/media/new_customer.03ddb79e8bd7e37fcac82c6c085d92a1.svg";
export { ForwardRef as ReactComponent };